<template>
  <div>
    <!--【container】circle or last page without circle -->
    <div :class="circleClass" class="overflow-hidden flex justify-center items-center mx-auto">
      <!--【img】human -->
      <img :class="currentScreen.zoom" :src="currentScreen.src" class="z-10" />
      <!--【img】front back -->
      <div class="flex justify-center items-center absolute w-full h-full">
        <div v-for="item in frontItems" :key="item.id" class="z-20">
          <img :src="item.src" :class="item.cls" />
        </div>
        <div v-for="item in backItems" :key="item.id" class="z-0">
          <img :src="item.src" :class="item.cls" />
        </div>
      </div>
      <!--【text】next forward -->
      <div class="flex justify-center items-center absolute w-full h-full">
        <div v-for="text in texts" :key="text.id">
          <span :class="text.cls">{{ text.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TutorialDoll',
  computed: {
    circleClass() {
      return this.currentScreen.zoom !== 'transition'
        ? 'circle border border-solid border-black'
        : '';
    },
    frontItemExist() {
      return typeof this.currentScreen.frontImg !== 'undefined';
    },
    frontItems() {
      return this.frontItemExist ? this.currentScreen.frontImg : '';
    },
    backItemExist() {
      return typeof this.currentScreen.backImg !== 'undefined';
    },
    backItems() {
      return this.backItemExist ? this.currentScreen.backImg : '';
    },
    textExist() {
      return typeof this.currentScreen.text !== 'undefined';
    },
    texts() {
      return this.textExist ? this.currentScreen.text : '';
    },
  },
  props: {
    currentScreen: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.transition.circleText {
  width: 96px;
  height: 50px;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.08;
  letter-spacing: normal;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.transition {
  height: 560px;
}
.solidBlud {
  width: 58.6px;
  height: 58.6px;
}
.circleText {
  width: 49px;
  height: 36px;
  background-color: #cedde5;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.transition.loadCircle {
  width: 180px;
  height: 180px;
}
.loadCircle {
  width: 97px;
}
.flip.fullBody {
  transform: scaleX(-1);
}
.fullBodyFist {
  height: 64vw;
}
.handCircle {
  width: 195px;
  height: 197px;
}
.circle {
  border-radius: 50%;
  width: 70vw;
  height: 70vw;
  border-color: #5b5b5b;
}
.fullBody {
  height: 52vw;
}
// page 4
.lFoot {
  margin-left: -23vw;
  margin-top: -22vw;
  animation: lFoot 3s 0s ease-in-out both;
}
.rFoot {
  margin-left: 14vw;
  margin-top: -22vw;
  animation: rFoot 3s 0s ease-in-out both;
}
@media screen and (min-width: 1024px) {
  .lFoot {
    margin-left: -17vw;
    margin-top: -16.5vw;
  }
  .rFoot {
    margin-left: 10vw;
    margin-top: -16.5vw;
  }
}
// page 4 animations
@keyframes lFoot {
  0% {
    transform: translate(0px, 0px);
  }
  40% {
    transform: translate(0px, 0px);
  }
  100% {
    transform: translate(50px, 110px);
  }
}
@keyframes rFoot {
  0% {
    transform: translate(0px, 0px) scaleX(-1);
  }
  40% {
    transform: translate(0px, 0px) scaleX(-1);
  }
  100% {
    transform: translate(-55px, 110px) scaleX(-1);
  }
}
</style>
